import { render, staticRenderFns } from "./ShowcaseTemplateOrgaSelect.vue?vue&type=template&id=290c09c0&"
import script from "./ShowcaseTemplateOrgaSelect.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseTemplateOrgaSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports